<div class="abook-snackbar">
  <div class="info">
    <h4>{{ data.title }}</h4>
    <p>{{ data.message }}</p>
  </div>
  <div class="actions">
    @if (data.actionDismissText) {
      <button class="abook-button --secondary" mat-flat-button (click)="onClose()">{{ data.actionDismissText }}</button>
    }
    @if (data.actionOneText) {
      <button mat-flat-button (click)="actionOne()">{{ data.actionOneText }}</button>
    }
  </div>
</div>
